<script lang="ts">
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';
    import ReportFondDetail from '../components/ReportFondDetail.svelte';
    import ReportWorker from '../components/ReportWorker.svelte';
    import ReportWorkerPowerKeySum from '../components/ReportWorkerPowerKeySum.svelte';

    export let record: RecordRow;

    const workerField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.workerFieldId);
    const dateField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.dateFieldId);
    const reportedPersonStandardField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedPersonStandardFieldId);
    const personUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.personUnitFieldId);
</script>

<ReportFondDetail {record} on:text-note-edit>
    <svelte:fragment slot="heading">
        <ReportWorker {workerField}/>
    </svelte:fragment>

    <svelte:fragment slot="details">
        <LabeledValue label="Vykázáno">
            <GridFieldValue field={reportedPersonStandardField} unitField={personUnitField}/>
        </LabeledValue>

        <LabeledValue label="Vykázáno v PwK">
            <ReportWorkerPowerKeySum {workerField} {dateField}/>
        </LabeledValue>
    </svelte:fragment>
</ReportFondDetail>